export default {
  userGroups: '/mrx-gateway/mrxassistmemberservice/admin/api/usergroups',
  users: '/mrx-gateway/mrxassistmemberservice/admin/api/users',
  userGroupsByUser: userSeq => `/mrx-gateway/mrxassistmemberservice/admin/api/user/${userSeq}/usergroup`,
  usersByUserGroup: userGroupId => `/mrx-gateway/mrxassistmemberservice/admin/api/usergroup/${userGroupId}/user`,
  userGrouptoUserHistory: userSeq => `/mrx-gateway/mrxassistmemberservice/admin/api/usergroup/${userSeq}/userhistory`,
  usertoUserGroupHistory: userGroupId => `/mrx-gateway/mrxassistmemberservice/admin/api/usergroup/${userGroupId}/usergrouphistory`,
  delUserFromUserGroup: (userSeq, userGroupId) => `/mrx-gateway/mrxassistmemberservice/admin/api/user/${userSeq}/usergroup/${userGroupId}`,
  addToUserGroup: (userSeq, userGroupId) => `/mrx-gateway/mrxassistmemberservice/admin/api/user/${userSeq}/usergroup/${userGroupId}`
}
